module.exports = __webpack_public_path__ + "static/media/login-bg-2.7e80a547.jpg";